module.exports = __webpack_public_path__ + "img/avatar.4c2fcd00.png";